"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPublicPricelist = exports.getPublicPricelists = exports.deletePricelistRelation = exports.postPricelistRelation = exports.putPricelistOrganization = exports.putPricelistAccessibility = exports.deletePricelistPermission = exports.postPricelistPermission = exports.putPricelistAction = exports.postPricelist = exports.putPricelist = exports.getPricelist = exports.getPricelists = void 0;

var common_1 = require("../common");

var root_1 = require("./root");

var pricelistsAuthorizedPath = root_1.ecommerceAuthorized + '/pricelists/';
var pricelistsPublicPath = root_1.ecommercePublic + '/pricelists/';

var getPricelists = function getPricelists(authentication, queryParameters) {
  return common_1.get(authentication, pricelistsAuthorizedPath, queryParameters);
};

exports.getPricelists = getPricelists;

var getPricelist = function getPricelist(authentication, id) {
  return common_1.get(authentication, pricelistsAuthorizedPath + id);
};

exports.getPricelist = getPricelist;

var putPricelist = function putPricelist(authentication, pricelist) {
  return common_1.put(authentication, pricelistsAuthorizedPath + pricelist.id, pricelist);
};

exports.putPricelist = putPricelist;

var postPricelist = function postPricelist(authentication, pricelist) {
  return common_1.post(authentication, pricelistsAuthorizedPath, pricelist);
};

exports.postPricelist = postPricelist;

var putPricelistAction = function putPricelistAction(authentication, id, action, data) {
  return common_1.putSub(authentication, pricelistsAuthorizedPath, id, action, data);
};

exports.putPricelistAction = putPricelistAction;

var postPricelistPermission = function postPricelistPermission(authentication, id, permission) {
  return common_1.postPermission(authentication, pricelistsAuthorizedPath, id, permission);
};

exports.postPricelistPermission = postPricelistPermission;

var deletePricelistPermission = function deletePricelistPermission(authentication, id, permissionId) {
  return common_1.deletePermission(authentication, pricelistsAuthorizedPath, id, permissionId);
};

exports.deletePricelistPermission = deletePricelistPermission;

var putPricelistAccessibility = function putPricelistAccessibility(authentication, id, accessibility) {
  return common_1.putAccessibility(authentication, pricelistsAuthorizedPath, id, accessibility);
};

exports.putPricelistAccessibility = putPricelistAccessibility;

var putPricelistOrganization = function putPricelistOrganization(authentication, id, accessibility) {
  return common_1.putEntityOrganization(authentication, pricelistsAuthorizedPath, id, accessibility);
};

exports.putPricelistOrganization = putPricelistOrganization;

var postPricelistRelation = function postPricelistRelation(authentication, id, relation) {
  return common_1.postRelation(authentication, pricelistsAuthorizedPath, id, relation);
};

exports.postPricelistRelation = postPricelistRelation;

var deletePricelistRelation = function deletePricelistRelation(authentication, id, relationId) {
  return common_1.deleteRelation(authentication, pricelistsAuthorizedPath, id, relationId);
};

exports.deletePricelistRelation = deletePricelistRelation;

var getPublicPricelists = function getPublicPricelists(authentication, queryParameters) {
  return common_1.get(authentication, pricelistsPublicPath, queryParameters);
};

exports.getPublicPricelists = getPublicPricelists;

var getPublicPricelist = function getPublicPricelist(authentication, id) {
  return common_1.get(authentication, pricelistsPublicPath + id);
};

exports.getPublicPricelist = getPublicPricelist;